import { render, staticRenderFns } from "./mailing_preview.vue?vue&type=template&id=0d41bb23&"
import script from "./mailing_preview.vue?vue&type=script&lang=js&"
export * from "./mailing_preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d41bb23')) {
      api.createRecord('0d41bb23', component.options)
    } else {
      api.reload('0d41bb23', component.options)
    }
    module.hot.accept("./mailing_preview.vue?vue&type=template&id=0d41bb23&", function () {
      api.rerender('0d41bb23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/mailings/mailing_preview.vue"
export default component.exports